<template lang="pug">
  .kr-help-modal-content
    .kr-help-content(v-for="(text, idx) in contentTexts")
      p(:id="uniqUidList[idx]") {{ text }}
    div(v-if="helpImage" :class="dynamicClasses.image" data-testid="imageWrapper")
      SvgImage(:aria-label="label" :aria-describedby="describerIdList" :template="helpImage")
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { dynamicMapState } from '@/common/util/store'
import { assets } from '@/common/loader/assets'
import SvgImage from '@/common/components/SvgImage'

/**
 * Extracted from KryptonHelpIcon to separate content logic.
 * Then refactor to properly handle template instead of building a string
 * to insert in a v-html. This was necessary to allow refactive attributes
 * added to SVG for ARIA.
 *
 * @since KJS-5012
 */
export default {
  name: 'HelpButtonContent',
  components: { SvgImage },
  inject: ['context'],
  props: {
    fieldName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      helpImage: undefined
    }
  },
  computed: {
    ...mapGetters(['translate']),
    ...mapState(['language']),
    ...dynamicMapState('context.namespace', ['selectedBrand']),
    isCVV() {
      return this.fieldName === 'securityCode'
    },
    isAmex() {
      return this.selectedBrand === 'AMEX'
    },
    contentKeys() {
      const fieldKey = this.fieldName === 'pan' ? 'pan' : 'cvv'

      if (fieldKey === 'cvv' && this.selectedBrand === 'AMEX') {
        return ['amex_cvv_help_1', 'amex_cvv_help_2']
      } else if (fieldKey === 'pan' || fieldKey === 'cvv') {
        return [`${fieldKey}_help_1`, `${fieldKey}_help_2`]
      }
      return []
    },
    contentTexts() {
      return this.contentKeys.map(key => this.translate(key))
    },
    uniqUidList() {
      return this.contentTexts.map((_, idx) => `kr-help-${this._uid}-${idx}`)
    },
    label() {
      return this.translate('label_cvv_help_image')
    },
    describerIdList() {
      return this.uniqUidList.join(' ')
    },
    dynamicClasses() {
      return {
        // If AMEX, use the specific image for the security code (See KJS-4028)
        image: {
          'kr-help-image': !this.isAmex,
          'kr-help-image-amex': this.isAmex
        }
      }
    }
  },
  watch: {
    async selectedBrand() {
      await this.setHelpImage()
    }
  },
  async created() {
    await this.setHelpImage()
  },
  methods: {
    async setHelpImage() {
      if (this.isCVV) {
        const { help } = assets

        this.helpImage = this.isAmex
          ? await help.securityCodeAmex()
          : await help.securityCode()
      }
    }
  }
}
</script>
